import React, { useMemo, useState } from 'react';
import { Box, Button, Collapse, List } from '@mui/material';
import { SidebarPanel } from '../SidebarPanel';
import { BirthdayItem } from './components/BirthdayItem';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { useGetUpcomingBirthdaysOfMembers } from '@reactQuery/manageMembers';

export const Birthdays = () => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState<boolean>(false);

  const { data: birthdays } = useGetUpcomingBirthdaysOfMembers();

  const { birthdaysToday, initialUpcoming, remainingUpcoming, hasMore } =
    useMemo(() => {
      if (!birthdays?.length) {
        return {
          birthdaysToday: [],
          initialUpcoming: [],
          remainingUpcoming: [],
          hasMore: false,
        };
      }

      const today = dayjs().startOf('day');

      const birthdaysToday = birthdays.filter((b) =>
        dayjs(b.nextBirthday).isSame(today, 'day')
      );

      const upcoming = birthdays.filter(
        (b) => !dayjs(b.nextBirthday).isSame(today, 'day')
      );

      const remainingSlots = Math.max(0, 5 - birthdaysToday.length);

      const initialUpcoming = upcoming.slice(0, remainingSlots);
      const remainingUpcoming = upcoming.slice(remainingSlots);

      return {
        birthdaysToday,
        initialUpcoming,
        remainingUpcoming,
        hasMore: remainingUpcoming.length > 0,
      };
    }, [birthdays]);

  if (!birthdays?.length) {
    return null;
  }

  return (
    <SidebarPanel title={t('panels:upcomingBirthdays.title')}>
      <List disablePadding>
        {birthdaysToday.map((birthday) => (
          <BirthdayItem
            key={birthday.slug}
            name={birthday.name}
            nextBirthday={dayjs(birthday.nextBirthday)}
            slug={birthday.slug}
            age={birthday.age}
          />
        ))}

        {initialUpcoming.map((birthday) => (
          <BirthdayItem
            key={birthday.slug}
            name={birthday.name}
            nextBirthday={dayjs(birthday.nextBirthday)}
            slug={birthday.slug}
            age={birthday.age}
          />
        ))}

        <Collapse in={expanded}>
          {remainingUpcoming.map((birthday) => (
            <BirthdayItem
              key={birthday.slug}
              name={birthday.name}
              nextBirthday={dayjs(birthday.nextBirthday)}
              slug={birthday.slug}
              age={birthday.age}
            />
          ))}
        </Collapse>
      </List>

      {hasMore && (
        <Box sx={{ textAlign: 'center', mt: 1 }}>
          <Button onClick={() => setExpanded((prev) => !prev)}>
            {expanded ? t('buttons.showLess') : t('buttons.showMore')}
          </Button>
        </Box>
      )}
    </SidebarPanel>
  );
};
